import {
  Flex,
  Text,
  SimpleGrid,
  Button,
  Modal as ModalMantine,
  useMantineTheme,
  ScrollArea,
  Tooltip,
} from "@mantine/core";
import { FormProvider, useForm } from "react-hook-form";
import {
  Modal,
  IMaskInputControlled,
  TextInputControlled,
} from "../../../../components";
import { useEffect, useState } from "react";
import { EmailsBrokers } from "./EmailsBrokers";
import { useAddressByCEP } from "../../../../hooks/useCEP";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotificationControl } from "../../../../context/notificationContext";
import { putUser } from "../../../../hooks/useUsers";
import { useUserIP } from "../../../../hooks/useAuthService";
import { InfoCircle } from "iconsax-react";
import { IFormUser, INewUser } from "../../../../interfaces/User/newUser";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationEditUser } from "../../../../utils/validation";
import { client_selected } from "../../../../client";
import { useMediaQuery } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

interface IProps {
  opened: boolean;
  close: any;
}

const ModalEditProfile = ({ close, opened }: IProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const queryClient = useQueryClient();
  const { notificationControl } = useNotificationControl();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const data = queryClient.getQueryData<INewUser>(["user"]);
  const isLargerThan991 = useMediaQuery("(min-width: 991px)");

  const {
    data: dataIp,
    //  isError: isErrorIp
  } = useUserIP();

  const userIp = !!dataIp?.data.ip ? dataIp?.data.ip : "";
  // const [errorIp, setErrorIp] = useState<string | null>(null);

  const methods = useForm<IFormUser>({
    mode: "onChange",
    resolver: yupResolver(validationEditUser),
    defaultValues: {
      cell_phone: data?.cell_phone || "",
      name: data?.name || "",
      document_nr: data?.document_nr || "",
      email: data?.email || "",
      client_ip: userIp,
      secondary_emails: data?.secondaryEmails,
      display_name: data?.display_name || "",
      address: {
        id: data?.address?.id,
        cep: data?.address?.cep || "",
        street: data?.address?.street || "",
        neighborhood: data?.address?.neighborhood || "",
        city: data?.address?.city || "",
        state: data?.address?.state || "",
        country: "BR",
        additional_address: data?.address?.additional_address || "",
        number: data?.address?.number || "",
      },
      notifications: data?.notifications || {
        email_executed_user_plan_action: false,
        email_new_order_sent: false,
        email_scheduled_user_plan_action: false,
      },
    },
  });

  const {
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = methods;

  const hasZipCode = watch("address.cep")?.length === 9;
  const hasErrorZipCode = errors?.address?.cep?.message;

  const { data: dataCep, isError: isErrorCep } = useAddressByCEP({
    cep: watch("address.cep"),
    enable: !!!data?.address?.cep,
  });

  useEffect(() => {
    if (!hasZipCode || isErrorCep) {
      setValue("address.street", "");
      setValue("address.neighborhood", "");
      setValue("address.city", "");
      setValue("address.state", "");
      setValue("address.country", "BR");
      setValue("address.additional_address", "");
      setValue("address.number", "");
      return;
    }
    if (!!dataCep && data?.address?.cep !== watch("address.cep")) {
      setValue("address.street", dataCep?.street || "");
      setValue("address.neighborhood", dataCep?.neighborhood || "");
      setValue("address.city", dataCep?.city || "");
      setValue("address.state", dataCep?.state || "");
      setValue("address.country", "BR");
      setValue(
        "address.additional_address",
        data?.address?.additional_address || ""
      );
      setValue("address.number", data?.address?.number || "");
      return;
    }
    if (data?.address?.cep === watch("address.cep")) {
      setValue(
        "address.street",
        data?.address?.street || dataCep?.street || ""
      );
      setValue(
        "address.neighborhood",
        data?.address?.neighborhood || dataCep?.neighborhood || ""
      );
      setValue("address.city", data?.address?.city || dataCep?.city || "");
      setValue("address.state", data?.address?.state || dataCep?.state || "");
      setValue("address.country", "BR");
      setValue(
        "address.additional_address",
        data?.address?.additional_address || ""
      );
      setValue("address.number", data?.address?.number || "");
      return;
    }
    // if (isErrorCep) {
    //   setError("address.cep", { message: "CEP inválido" });
    // }
    //eslint-disable-next-line
  }, [dataCep, hasZipCode, isErrorCep]);

  const styleSpecialDisabled = {
    root: {
      ":disabled": {
        backgroundColor: theme.colors.basic[1],
        color: "black",
        border: "1px solid #E0E0E0",
      },
    },
    input: {
      ":disabled": {
        backgroundColor: theme.colors.basic[1],
        color: "black",
        border: "1px solid #E0E0E0",
        ":hover": {
          backgroundColor: theme.colors.basic[1],
          color: "black",
          border: "1px solid #E0E0E0",
        },
      },
    },
    wrapper: {
      ":disabled": {
        backgroundColor: theme.colors.basic[1],
        color: "black",
        border: "1px solid #E0E0E0",
      },
    },
  };
  // const notify = [
  //   {
  //     name: "Notificação de envio de ordem",
  //     key: "notifications.email_new_order_sent",
  //   },
  //   {
  //     name: "Alteração de configuração",
  //     key: "notifications.email_scheduled_user_plan_action",
  //   },
  //   {
  //     name: "Execução de configuração",
  //     key: "notifications.email_executed_user_plan_action",
  //   },
  // ] as const;

  const { mutate: editUser } = useMutation(putUser, {
    onSuccess: () => {
      setOpenModal(!openModal);
      queryClient.invalidateQueries(["user"]);
      setIsLoading(false);
    },
    onError: (errors) => {
      console.error(t("meu_perfil.configuracoes.modal_edit.error"), errors);
      notificationControl({
        message: t("meu_perfil.configuracoes.modal_edit.error"),
        type: "danger",
      });
      setIsLoading(false);
    },
  });

  const onSubmit = (data: IFormUser) => {
    // setErrorIp(null);
    setIsLoading(true);
    // if (!!!userIp && !!isErrorIp) {
    //   setErrorIp("Falha ao obter o endereço IP. Entre em contato com Suporte.");
    //   setIsLoading(false);
    //   return;
    // }
    const { name, document_nr, email, secondary_emails, ...oldData } = data;
    const cleanEmails = secondary_emails.map(
      (secondarayEmail) => secondarayEmail.email
    );
    const newData = { ...oldData, secondary_emails: cleanEmails };
    newData.client_ip = userIp;

    editUser(newData);
  };

  const handleClose = () => {
    close();
    setOpenModal(false);
  };
  return (
    <>
      <Modal
        type="success"
        titleSeccondButton="Fechar"
        description={t("meu_perfil.configuracoes.modal_edit.success")}
        open={openModal}
        setClose={handleClose}
        firstClick={() => {}}
        secondClick={handleClose}
      />
      <ModalMantine.Root
        centered
        opened={opened}
        onClose={handleClose}
        size={"auto"}
        fullScreen={!isLargerThan991}
        scrollAreaComponent={ScrollArea.Autosize}
        styles={{
          header: { padding: 0 },
          close: {
            position: "absolute",
            top: "24px",
            right: "24px",
          },
          body: {
            padding: 0,
            width: "100%",
            maxWidth: "1200px",
          },
          content: {
            width: "100%",
            maxWidth: "1200px !important",
          },
        }}
        radius={"10px"}
      >
        <ModalMantine.Overlay />
        <ModalMantine.Content>
          <ModalMantine.Header>
            <ModalMantine.CloseButton />
          </ModalMantine.Header>
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <ModalMantine.Body>
                {/* <Flex w={"100%"} direction="column" gap={24} h="100%"> */}
                <Flex
                  w={"100%"}
                  maw={1200}
                  direction="column"
                  gap={32}
                  bg="basic.0"
                  p={{
                    base: "32px 24px",
                    991: "32px 48px 120px",
                  }}
                  sx={{
                    borderRadius: "12px",
                    boxShadow: "0px 25px 35px rgba(0, 0, 0, 0.03)",
                  }}
                >
                  <Flex w={"100%"} direction="column" gap={24}>
                    <Text
                      mx={"auto"}
                      fz={{ base: 24 }}
                      fw={{ base: 600 }}
                      lh={{ base: "37.2px" }}
                      c={"basic.5"}
                    >
                      {t("meu_perfil.configuracoes.modal_edit.title")}
                    </Text>
                    <SimpleGrid
                      id="gridAdressOne"
                      cols={1}
                      breakpoints={[
                        { minWidth: "991", cols: 2, spacing: "32px" },
                        { minWidth: "1600", cols: 3, spacing: "32px" },
                      ]}
                    >
                      <TextInputControlled
                        name="name"
                        label={t("global.input.name.label")}
                        withAsterisk
                        placeholder={t("global.input.name.placeholder")}
                        disabled={true}
                      />
                      <IMaskInputControlled
                        name="document_nr"
                        label={t("global.input.document_nr.label")}
                        placeholder="000.000.000-00"
                        mask="000.000.000-00"
                        withAsterisk
                        disabled={true}
                      />
                      <TextInputControlled
                        name="email"
                        label={t("global.input.email.label")}
                        withAsterisk
                        placeholder={t("global.input.email.label")}
                        disabled={true}
                      />
                      <IMaskInputControlled
                        name="cell_phone"
                        label={t("global.input.cell_phone.label")}
                        placeholder="(00) 00000-0000"
                        mask="(00) 00000-0000"
                        withAsterisk
                      />
                    </SimpleGrid>
                  </Flex>

                  {client_selected.hasBrokers ? <EmailsBrokers /> : null}

                  <Flex w={"100%"} direction="column" gap={24}>
                    <Flex gap="12px" align="center">
                      <Text fw={600} size={24} color={theme.colors.basic[5]}>
                        {t("meu_perfil.configuracoes.modal_edit.address")}
                      </Text>
                      <Tooltip
                        withArrow
                        label={t(
                          "meu_perfil.configuracoes.modal_edit.tooltip_address"
                        )}
                        multiline
                        width={220}
                        position="top-start"
                      >
                        <InfoCircle
                          size="24"
                          color={theme.colors.basic[4]}
                          variant="Bold"
                        />
                      </Tooltip>
                    </Flex>

                    <SimpleGrid
                      id="gridAdressOne"
                      cols={1}
                      breakpoints={[
                        { minWidth: "991", cols: 2, spacing: "32px" },
                        { minWidth: "1600", cols: 3, spacing: "32px" },
                      ]}
                    >
                      <IMaskInputControlled
                        name="address.cep"
                        label={t("global.input.cep.label")}
                        placeholder="00000-000"
                        mask="00000-000"
                        withAsterisk
                      />

                      <TextInputControlled
                        name="address.state"
                        label={t("global.input.state.label")}
                        placeholder={
                          isErrorCep ? "digite um CEP Válido" : "Digite o CEP"
                        }
                        withAsterisk
                        disabled={true}
                        width={"100%"}
                        sx={
                          !isErrorCep && !hasErrorZipCode && hasZipCode
                            ? styleSpecialDisabled
                            : {}
                        }
                      />
                      <TextInputControlled
                        name="address.city"
                        label={t("global.input.city.label")}
                        placeholder={
                          isErrorCep ? "digite um CEP Válido" : "Digite o CEP"
                        }
                        withAsterisk
                        disabled={true}
                        width={"100%"}
                        sx={
                          !isErrorCep && !hasErrorZipCode && hasZipCode
                            ? styleSpecialDisabled
                            : {}
                        }
                      />
                      <TextInputControlled
                        name="address.neighborhood"
                        label={t("global.input.neighborhood.label")}
                        placeholder={
                          isErrorCep
                            ? t("global.input.cep.placeholder_error_inputs")
                            : hasZipCode
                            ? t("global.input.neighborhood.placeholder")
                            : t("global.input.cep.placeholder_other_inputs")
                        }
                        withAsterisk
                        disabled={isErrorCep || !hasZipCode}
                        width={"100%"}
                      />
                      <TextInputControlled
                        name="address.street"
                        label={t("global.input.street.label")}
                        placeholder={
                          isErrorCep
                            ? t("global.input.cep.placeholder_error_inputs")
                            : hasZipCode
                            ? t("global.input.street.placeholder")
                            : t("global.input.cep.placeholder_other_inputs")
                        }
                        withAsterisk
                        disabled={isErrorCep || !hasZipCode}
                      />
                      <TextInputControlled
                        name="address.number"
                        label={t("global.input.number.label")}
                        placeholder={
                          isErrorCep
                            ? t("global.input.cep.placeholder_error_inputs")
                            : hasZipCode
                            ? t("global.input.number.placeholder")
                            : t("global.input.cep.placeholder_other_inputs")
                        }
                        disabled={isErrorCep || !hasZipCode}
                      />
                      <TextInputControlled
                        name="address.additional_address"
                        label={t("global.input.additional_address.label")}
                        placeholder={
                          isErrorCep
                            ? t("global.input.cep.placeholder_error_inputs")
                            : hasZipCode
                            ? t("global.input.additional_address.placeholder")
                            : t("global.input.cep.placeholder_other_inputs")
                        }
                        disabled={isErrorCep || !hasZipCode}
                      />
                    </SimpleGrid>

                    {/* <Flex w={"100%"} direction="column" gap={24}>
                      <Flex gap="12px" align="center">
                        <Text fw={600} size={24} color={theme.colors.basic[5]}>
                          {t("meu_perfil.configuracoes.modal_edit.notifications")}
                        </Text>
                        <Tooltip
                          withArrow
                          label={t("meu_perfil.configuracoes.modal_edit.tooltip_notifications")}
                          multiline
                          width={220}
                          position="top-start"
                        >
                          <InfoCircle
                            size="24"
                            color={theme.colors.basic[4]}
                            variant="Bold"
                          />
                        </Tooltip>
                      </Flex>

                      <Flex
                        gap={{ base: 24, 991: 32 }}
                        wrap="wrap"
                        justify={"start"}
                      >
                        {notify.map((item) => {
                          return (
                            <RadioGroup
                              label={item.name}
                              value={!!watch(item.key) ? "ATIVO" : "INATIVO"}
                              onChange={(value) =>
                                setValue(item.key, value === "ATIVO")
                              }
                              miw="200px"
                            >
                              <Flex
                                mt="8px"
                                gap="24px"
                                h="28px"
                                align={"center"}
                              >
                                <Radio value="ATIVO" label={t("global.status.active")} />
                                <Radio value="INATIVO" label={t("global.status.inactive")} />
                              </Flex>
                            </RadioGroup>
                          );
                        })}
                      </Flex>
                    </Flex> */}
                  </Flex>
                </Flex>
                {/* </Flex> */}
              </ModalMantine.Body>
              <Flex
                style={{
                  position: isLargerThan991 ? "absolute" : "fixed",
                  bottom: 0,
                  right: 0,
                }}
                w="100%"
                p={{ base: 16, 991: "32px 48px" }}
              >
                <Button
                  type="submit"
                  variant="primary"
                  fullWidth
                  loading={isLoading}
                  // disabled={!isDirty || !isValid || !accept}
                >
                  {t("meu_perfil.configuracoes.modal_edit.button_save")}
                </Button>
              </Flex>
            </form>
          </FormProvider>
        </ModalMantine.Content>
      </ModalMantine.Root>
    </>
  );
};

export default ModalEditProfile;
